import React from 'react';
import { motion } from 'framer-motion';
import { SlideStage } from '../../components/deck/SlideStage';
import { NativeCallLogPhone } from '../../components/deck/NativeCallLogPhone';
import { MissedCallCounter } from '../../components/deck/MissedCallCounter';
import { dayTimeline, hiddenIntents } from '../../data/deckSlide2';
const VEXU_LOGO = 'https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg';
const ease = [0.22, 0.61, 0.36, 1] as const;

/** Restrained warm accent used only for the missed calls. */
const MISSED = '#B4543A';
const T = {
  headline: 0.2,
  timeline: 0.9,
  phone: 2.1,
  counter: 2.6,
  insight: 3.8,
  intents: 4.6,
  callback: 5.5,
  question: 6.3
};
const ROW_HEIGHT = 42;
export function ProblemSlide() {
  return <SlideStage data-id="element-2562" data-mp="30x4xhptsiser">
      <div className="deck-type absolute inset-0 overflow-hidden bg-[#FAFCF9]" data-id="element-2563" data-mp="1uegkvlkf5iav">
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse 90% 70% at 8% -18%, rgba(0,200,83,0.06) 0%, rgba(250,252,249,0) 60%), radial-gradient(ellipse 50% 55% at 84% 40%, rgba(180,84,58,0.05) 0%, rgba(250,252,249,0) 68%), linear-gradient(180deg, #FBFDFA 0%, #F5F8F3 55%, #EFF3ED 100%)'
      }} data-id="element-2564" data-mp="1ucc7md0mr6xx" />

        {/* Brand header */}
        <motion.div className="absolute flex items-center gap-3" style={{
        left: 112,
        top: 56
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease
      }} data-id="element-2565" data-mp="21axsjckqbbkl">
          <img src={VEXU_LOGO} alt="" className="w-7 h-7 object-contain" data-id="element-2566" data-mp="1sc2kduy4jren" />
          <span className="text-[16px] font-bold tracking-tight text-[#0B1712]" data-id="element-2567" data-mp="1dmekmy5ld0t1">
            Vexu.ai
          </span>
        </motion.div>
        <motion.span className="absolute text-[11px] font-semibold uppercase tracking-[0.28em] text-[#8A998F]" style={{
        right: 112,
        top: 62
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease
      }} data-id="element-2568" data-mp="1ikziiqxdf8eb">
          02 · The Problem
        </motion.span>

        {/* Headline */}
        <h1 className="absolute text-[48px] font-semibold leading-[1.16] tracking-[-0.02em] text-[#0B1712]" style={{
        left: 112,
        top: 152,
        width: 820
      }} data-id="element-2569" data-mp="36hfsvgc09bj1">
          {['Your workday ends.', 'Your missed calls don’t.'].map((line, i) => <motion.span key={line} className="block" initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: T.headline + i * 0.16,
          ease
        }} data-id="element-2570" data-mp="3u81rkh04djgd" data-mpi={i}>
              {line}
            </motion.span>)}
        </h1>

        {/* LEFT — the busy day */}
        <div className="absolute" style={{
        left: 112,
        top: 340,
        width: 380
      }} data-id="element-2571" data-mp="3gad4d2iky085">
          <motion.p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-[#8A998F]" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: T.timeline - 0.2,
          ease
        }} data-id="element-2572" data-mp="28w9yy9st23nv">
            One day. One calendar.
          </motion.p>

          <div className="relative mt-7 pl-[68px]" data-id="element-2573" data-mp="oablvgxydp6x">
            <motion.span className="absolute left-[57px] top-2 w-px bg-[#0B1712]/10" initial={{
            height: 0
          }} animate={{
            height: ROW_HEIGHT * (dayTimeline.length - 1) + 8
          }} transition={{
            duration: 1.8,
            delay: T.timeline,
            ease
          }} data-id="element-2574" data-mp="tapub03gv15h" />
            {dayTimeline.map((entry, i) => {
            const isMissed = entry.kind === 'missed';
            const isEnd = entry.kind === 'end';
            return <motion.div key={`${entry.time}-${entry.label}`} className="relative flex items-center" style={{
              height: ROW_HEIGHT
            }} initial={{
              opacity: 0,
              x: -8
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.7,
              delay: T.timeline + i * 0.18,
              ease
            }} data-id="element-2575" data-mp="1h1va5f9eptfs" data-mpi={i}>
                  <span className="absolute -left-[68px] w-[46px] text-right text-[12px] font-medium tabular-nums" style={{
                color: isMissed ? `${MISSED}99` : '#8A998F'
              }} data-id="element-2576" data-mp="2ilt7req3b0yo">
                    {entry.time}
                  </span>
                  <span className="absolute -left-[14px] rounded-full" style={{
                width: isMissed ? 5 : 7,
                height: isMissed ? 5 : 7,
                background: isMissed ? MISSED : isEnd ? '#00C853' : '#0B1712',
                opacity: isMissed ? 0.85 : 1
              }} data-id="element-2577" data-mp="24pxzs3x8baa2" />
                  <span className={`text-[15px] ${isEnd ? 'font-semibold' : isMissed ? 'font-normal' : 'font-medium'}`} style={{
                color: isMissed ? MISSED : isEnd ? '#0B1712' : '#33463B'
              }} data-id="element-2578" data-mp="1h0devfhim2y5">
                    {entry.label}
                  </span>
                </motion.div>;
          })}
          </div>
        </div>

        {/* MIDDLE — the payoff, the insight, the callback */}
        <div className="absolute" style={{
        left: 620,
        top: 292,
        width: 380
      }} data-id="element-2579" data-mp="f8u00a15hd3z">
          <MissedCallCounter to={17} delay={T.counter} data-id="element-2580" data-mp="k9hr0vpdpty7" />

          <div className="mt-11 text-[30px] leading-[1.26] tracking-[-0.018em]" data-id="element-2581" data-mp="6arrzaj01k77">
            <motion.p className="text-[#5A6B60]" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: T.insight,
            ease
          }} data-id="element-2582" data-mp="abtt5wwh86bt">
              You know who called.
            </motion.p>
            <motion.p className="font-semibold text-[#0B1712]" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: T.insight + 0.35,
            ease
          }} data-id="element-2583" data-mp="11jc6exfw1zg7">
              You don’t know why.
            </motion.p>
          </div>

          <div className="mt-10 space-y-3 border-l border-[#0B1712]/10 pl-6" data-id="element-2584" data-mp="mv7klkljh7t7">
            {hiddenIntents.map((intent, i) => <motion.p key={intent} className="text-[15px] leading-snug text-[#5A6B60]" initial={{
            opacity: 0,
            x: -6
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.7,
            delay: T.intents + i * 0.2,
            ease
          }} data-id="element-2585" data-mp="iufakp4ueyvv" data-mpi={i}>
                {intent}
              </motion.p>)}
          </div>

          <motion.div className="mt-11" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: T.callback,
          ease
        }} data-id="element-2586" data-mp="1y92y6owsp8ib">
            <p className="text-[23px] font-semibold leading-[1.3] tracking-[-0.015em] text-[#0B1712]" data-id="element-2587" data-mp="2aqvy6vuub762">
              You call everyone back
              <br data-id="element-2588" data-mp="2fl9m6d76ac0p" />
              just to discover what they needed.
            </p>
            <p className="mt-3 text-[14px] leading-relaxed text-[#5A6B60]" data-id="element-2589" data-mp="2kh8e2arpmc5v">
              The action may take seconds. Discovering the intent requires
              another conversation.
            </p>
          </motion.div>
        </div>

        {/* RIGHT — the ordinary phone at the end of the day */}
        <motion.div className="absolute" style={{
        left: 1130,
        top: 214
      }} initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.1,
        delay: T.phone,
        ease
      }} data-id="element-2590" data-mp="1wuifjjekkzq0">
          <NativeCallLogPhone scale={0.62} rowDelay={T.phone + 0.3} data-id="element-2591" data-mp="3d5w56mz53vrc" />
        </motion.div>

        {/* Transition into Slide 3 */}
        <motion.p className="absolute text-right text-[22px] font-medium leading-[1.3] tracking-[-0.015em] text-vexu-700" style={{
        right: 112,
        bottom: 62,
        width: 460
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.2,
        delay: T.question,
        ease
      }} data-id="element-2592" data-mp="25vbrvmaplxv">
          What if a missed call
          <br data-id="element-2593" data-mp="lsjlheestzfv" />
          didn’t have to stay missed?
        </motion.p>
      </div>
    </SlideStage>;
}